import QueryString from "qs";
import { baseURL } from "../utilits/config";
import axios from "axios";

export function registerUsers(userData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/registerUser",
    headers: {
      "Content-Type": "application/json",
    },
    data: userData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function HandleAdminLogin(userData, callback) {
  let data = QueryString.stringify(userData);

  const config = {
    method: "post",
    url: baseURL + "/login",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((err) => {
      callback(err);
    });
}

export function getAdminAccounts(callback) {
  const config = {
    method: "get",
    url: baseURL + "/login",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error);
    });
}
